import gql from 'graphql-tag';

export default gql`
  mutation updateArtwork($input: UpdateArtworkInput!) {
    updateArtwork(input: $input) {
      id
      status
      name
      description
      userid
    }
  }
`;
